export const SYMBOL_DETAIL_TABS = {
  SUMMARY: 'summary',
  INDICATORS: 'indicators',
  CHART: 'chart',
  NEWS: 'news',
  HISTORICAL: 'historical'
};

export const ALL_TABS = [
  SYMBOL_DETAIL_TABS.SUMMARY,
  SYMBOL_DETAIL_TABS.INDICATORS,
  SYMBOL_DETAIL_TABS.CHART,
  SYMBOL_DETAIL_TABS.NEWS,
  SYMBOL_DETAIL_TABS.HISTORICAL
];

export const NON_JPEQ_TABS = [
  SYMBOL_DETAIL_TABS.CHART,
  SYMBOL_DETAIL_TABS.HISTORICAL
];
